import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
export const SidebarContext = /*#__PURE__*/ createContext(null);
export const useIsExpandMode = ()=>useContext(SidebarContext);
export const SidebarContextProvider = ({ children, expandMode })=>{
    return /*#__PURE__*/ React.createElement(SidebarContext.Provider, {
        value: expandMode
    }, children);
};
SidebarContextProvider.propTypes = {
    children: PropTypes.node,
    expandMode: PropTypes.bool
};
